module.exports = __webpack_public_path__ + "static/media/64.8b404d6f.png";